<template>
  <div>
    <table>
      <tr
        v-for="(fichier, index) of displayedFichiers"
        :key="index"
      >
        <td>{{ fichier.name }}</td>
        <td :title="fichier.fullsize">{{ fichier.formatsize }}</td>
        <td><button @click="renommerFichierImportation(fichier.name)">Renommer en .zip</button></td>
        <td><button @click="supprimerFichierImportation(fichier.name )">Supprimer</button></td>
        <td><button @click="getFichier(fichier.name)">Télécharger</button></td>
      </tr>
    </table>
    <Pagination
      :current="currentPage"
      :pages="pagesNumber"
      @change="changePage"
    />
    <div class="flex-fJstart-fAcenter">
      <p>
        <button @click="retour">Retour</button>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Pagination from './Pagination'

export default {
  components: { Pagination },
  data: function() {
    return {
      pageSize: 50,
      currentPage: 1
    }
  },
  created: function () {
    this.setFichiersImportation()
  },
  computed: {
    ...mapGetters([
      'fichiersImportation'
    ]),
    displayedFichiers: function() {
      let begin = (this.currentPage-1) * this.pageSize
      let end = (this.currentPage) * this.pageSize
      if (Array.isArray(this.fichiersImportation)) {
        return this.fichiersImportation.slice(begin, end)
      } else {
        return []
      }
    },
    pagesNumber: function() {
      if (Array.isArray(this.fichiersImportation)) {
        return Math.ceil(this.fichiersImportation.length / this.pageSize)
      }else {
        return 1
      }
    }
  },
  methods: {
    ...mapActions([
      'setFichiersImportation',
      'renommerFichierImportation',
      'supprimerFichierImportation'
    ]),
    getFichier: function(fichier) {
      window.location.href = '/admin/fichierimportation/download/' + fichier
    },
    retour: function() {
      window.location.href = '/openweb/admin/admin_importation'
    },
    changePage: function(page) {
      this.currentPage = page
    }
  }
}
</script>
